import __ from "../admin-utils/LanguageHelper";
import logo from "./logo"

const baseDomain = 'https://api.shiro.com.sa'
const baseUrl = baseDomain + '/v1'
const authables = []
const currency = __('ريال', 'SAR')

// Form Options
export const formOptions = {
  keepData: false,
  clearInputs: false,
  maxUpload: 5000
}

// Table Options
export const tableOptions = {

}

// PDF Options
export const pdfOptions = {
  allowPrint: false,
  logo
}

// Global Options
export const globalOptions = {
  enableAccessGuard: false,
}

export
{
  baseUrl,
  baseDomain,
  authables,
  currency,

}
